import {
  Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue,
} from "@/components/ui/select";

// Mobile-only "view switcher": replaces overflowing horizontal tab rows with a clean
// dropdown. Drives the same controlled state as the desktop <TabsList>. When options
// carry a `group`, they are rendered under an uppercase group label (e.g. Operativi/Analisi).
export const MobileViewSelect = ({ value, onValueChange, options, testid = "view-select" }) => {
  const hasGroups = options.some((o) => o.group);
  const grouped = hasGroups
    ? options.reduce((acc, o) => {
        const g = o.group || "";
        (acc[g] = acc[g] || []).push(o);
        return acc;
      }, {})
    : null;

  const renderItem = (o) => (
    <SelectItem key={o.value} value={o.value} data-testid={`${testid}-item-${o.value}`}>
      <span className="flex items-center gap-2">
        {o.Icon && <o.Icon className="h-4 w-4" />}
        {o.label}
      </span>
    </SelectItem>
  );

  return (
    <div className="md:hidden sticky top-16 z-30 mb-4 py-2 bg-background/90 backdrop-blur-md">
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger
          data-testid={`${testid}-trigger`}
          className="w-full h-11 rounded-none border-[hsl(var(--primary))]/40 bg-card/70 text-[hsl(var(--primary))] uppercase tracking-[0.12em] text-sm font-semibold focus:ring-[hsl(var(--primary))]/40"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="rounded-none border-[hsl(var(--primary))]/40 bg-background">
          {hasGroups
            ? Object.entries(grouped).map(([g, items]) => (
                <SelectGroup key={g}>
                  <SelectLabel className="text-[10px] md:text-xs uppercase tracking-[0.14em] text-muted-foreground/70">{g}</SelectLabel>
                  {items.map(renderItem)}
                </SelectGroup>
              ))
            : options.map(renderItem)}
        </SelectContent>
      </Select>
    </div>
  );
};
